import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

function TransportAdministrationPg() {
    return(
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Administration"/>
            <section className="project-detail">
                <div className='container'>
                    <div className="c-heading">  
                        <h1>Transportation</h1>
                    </div> 

                    <div className="border">
                            <div className='mt-3 ms-3'>
                                <h4>Bus Schedule </h4>
                                <ul className='myulcustarrow'>
                                    <li>
                                    <Link to ={"https://files.iittp.ac.in/pdfs/transportation/Proposed_Trips_Schedule_10.10.2024.pdf"} target="_blank" > Bus Schedule </Link>
                                     </li>
                                     
                                </ul>
                            </div>
                    </div> 
                </div>
                
            </section>
        </>
    );
}

export default TransportAdministrationPg;